import { useTranslations } from 'next-intl';
import styled from 'styled-components';
import { FacebookIcon, InstagramIcon, LinkedInIcon, XIcon } from '@/components/ui';

/** Bidali's social profiles (same list and URLs as the marketing site). */
export const SOCIALS = [
  { name: 'LinkedIn', href: 'https://linkedin.com/company/bidali', Icon: LinkedInIcon },
  { name: 'X', href: 'https://x.com/bidalihq', Icon: XIcon },
  { name: 'Instagram', href: 'https://instagram.com/bidalihq', Icon: InstagramIcon },
  { name: 'Facebook', href: 'https://facebook.com/bidalihq', Icon: FacebookIcon },
];

const List = styled.ul`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ProfileLink = styled.a`
  border-radius: var(--radius-sm);
  color: color-mix(in oklab, var(--foreground) 80%, transparent);
  display: block;
  transition: color 150ms;

  &:hover {
    color: var(--foreground);
  }
`;

/**
 * Row of social icons: LinkedIn, X, Instagram, Facebook.
 * The per-network URL props this component used to take are ignored; the
 * list above is the single source.
 */
const SocialMediaProfiles = ({ className, justifyContent = 'flex-end' }) => {
  const t = useTranslations('footer');

  return (
    <List className={className} $justifyContent={justifyContent}>
      {SOCIALS.map(({ name, href, Icon }) => (
        <li key={name}>
          <ProfileLink
            aria-label={t('social', { network: name })}
            href={href}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon size={24} />
          </ProfileLink>
        </li>
      ))}
    </List>
  );
};

export default SocialMediaProfiles;
